/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Observable } from 'rxjs/Observable';
import { Action } from '@ngrx/store';

import { Menu, Widget, Dashboard, ProgressIndicator } from '@api/models';

import * as ui from '../actions/ui.actions';

// Set theme state to link
let bodyClass = 'absav2';
if (document.getElementById('theme')) {
  let stylesheet = document.getElementById('theme') as HTMLLinkElement;
  let stylesheetArray = stylesheet.href.split('/');
  let stylesheetTheme = stylesheetArray[stylesheetArray.length-1];
  bodyClass = stylesheetTheme.substring(0, stylesheetTheme.lastIndexOf('.'));
}

/**
 * UI state
 */
export interface UIState {
  menus: Menu[];
  widgets: Widget[];
  dashboards: Dashboard[];
  collapsedSidenav: boolean;
  theme: string;
  progressIndicator: ProgressIndicator;
};

/**
 * Default UI state
 */
export const initialState: UIState = {
  menus: [],
  widgets: [],
  dashboards: [],
  collapsedSidenav: true,
  theme: bodyClass,
  progressIndicator: {}
};

/**
 * UI reducer
 * @param state The current state
 * @param action The action
 * @return The new state to redirect
 */
export function reducer(state: UIState = initialState, action: Action): UIState {
  switch (action.type) {

    case ui.LOAD_MENU_SUCCESS:
      return {
        menus: [...action.payload],
        widgets: [...state.widgets],
        dashboards: [...state.dashboards],
        collapsedSidenav: true,
        theme: state.theme.toString(),
        progressIndicator: state.progressIndicator
      };

    case ui.LOAD_DASHBOARD_MENU_SUCCESS:
      return {
        menus: [...state.menus],
        widgets: [...state.widgets],
        dashboards: [...action.payload],
        collapsedSidenav: state.collapsedSidenav,
        theme: state.theme.toString(),
        progressIndicator: state.progressIndicator
      };

    case ui.LOAD_DASHBOARD_SUCCESS:
      return {
        menus: [...state.menus],
        widgets: [...action.payload],
        dashboards: [...state.dashboards],
        collapsedSidenav: state.collapsedSidenav,
        theme: state.theme.toString(),
        progressIndicator: state.progressIndicator
      };

    case ui.OPEN_SIDENAV:
      return {
        menus: [...state.menus],
        widgets: [...state.widgets],
        dashboards: [...state.dashboards],
        collapsedSidenav: false,
        theme: state.theme.toString(),
        progressIndicator: state.progressIndicator
      };

    case ui.CLOSE_SIDENAV:
      return {
        menus: [...state.menus],
        widgets: [...state.widgets],
        dashboards: [...state.dashboards],
        collapsedSidenav: true,
        theme: state.theme.toString(),
        progressIndicator: state.progressIndicator
      };

    case ui.TOGGLE_SIDENAV:
      return {
        menus: [...state.menus],
        widgets: [...state.widgets],
        dashboards: [...state.dashboards],
        collapsedSidenav: !state.collapsedSidenav,
        theme: state.theme.toString(),
        progressIndicator: state.progressIndicator
      };

    case ui.GOTO_THEME_SUCCESS:
      return {
        menus: [...state.menus],
        widgets: [...state.widgets],
        dashboards: [...state.dashboards],
        collapsedSidenav: state.collapsedSidenav,
        theme: action.payload,
        progressIndicator: state.progressIndicator
      };

    case ui.SHOW_PROGRESS_INDICATOR:
      return {
        menus: state.menus,
        widgets: state.widgets,
        dashboards: state.dashboards,
        collapsedSidenav: state.collapsedSidenav,
        theme: state.theme.toString(),
        progressIndicator: Object.assign({}, action.payload)
      };

    default:
      return state;
  }
};

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

// export const getRedirectUrl = (state: UIState) => state.redirectUrl;
export const getMenus = (state: UIState) => state.menus;
export const getWidgets = (state: UIState) => state.widgets;
export const getDashboards = (state: UIState) => state.dashboards;
export const getCollapsedSidenav = (state: UIState) => state.collapsedSidenav;
export const getTheme = (state: UIState) => state.theme;
export const getProgressIndicator = (state: UIState) => state.progressIndicator;


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/store/reducers/ui.reducer.ts